<template>
  <div class="d-flex align-center ga-2">
    <v-btn
      v-if="can('document-agreements.print')"
      v-tooltip="'Друкувати'"
      border
      color="white"
      density="comfortable"
      icon
      @click="printDocument()">
      <v-icon color="grey-darken-3" icon="mdi-printer"></v-icon>
    </v-btn>

    <v-dialog v-if="participants.length" width="800">
      <template #activator="{ props }">
        <v-btn
          v-tooltip="'Процес погодження'"
          v-bind="props"
          border
          color="white"
          density="comfortable"
          icon>
          <v-icon color="grey-darken-3" icon="intime:account-multiple"></v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <participants></participants>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn
      v-if="documentAgreementSource.statusId === 4 && !relatedSignatures.length"
      v-tooltip="'Відправити на підписання'"
      border
      color="white"
      density="comfortable"
      icon
      :loading="$loading.isLoading('sendToSign')"
      @click="sendToSign">
      <v-icon color="grey-darken-3" icon="mdi-share"></v-icon>
    </v-btn>

    <v-btn
      v-if="
        can('document-agreements.delete') &&
        documentAgreementSource.statusId === 1 &&
        isAuthor
      "
      v-tooltip="'Видалити'"
      border
      color="error"
      density="comfortable"
      icon="mdi-delete"
      variant="outlined"
      :loading="$loading.isLoading('deleteDocument')"
      @click="deleteDocument"></v-btn>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../../documentAgreement'
import { useCan } from '@/composables/useCan'
import Participants from './Participants.vue'

export default {
  name: 'Actions',
  components: { Participants },
  setup() {
    const { can } = useCan()
    const printDocument = () => {
      can('document-agreements.print', () => {
        const iframe = window.document.querySelector('iframe')
        if (!iframe) return

        iframe.contentWindow?.focus()
        iframe.contentWindow?.print()
      })
    }

    return { ...useDocumentAgreement(), printDocument, can }
  },
}
</script>

<style scoped lang="scss"></style>
